import type { JSX } from 'preact';
import { cn } from '../lib/cn';

type Tone = 'neutral' | 'ok' | 'warn' | 'danger';
const tones: Record<Tone, string> = {
  neutral: 'bg-surface-muted/20 text-surface-fg',
  ok: 'bg-emerald-500/20 text-emerald-700',
  warn: 'bg-amber-500/20 text-amber-700',
  danger: 'bg-danger-500/20 text-danger-500',
};

export function Badge({
  tone = 'neutral',
  class: cls,
  ...rest
}: JSX.HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      {...rest}
      class={cn(
        'inline-flex items-center rounded px-2 py-0.5 text-xs font-medium',
        tones[tone],
        cls as string | undefined,
      )}
    />
  );
}
